import React from 'react';
import { omit } from 'lodash';
import withField from '../withField';
import { Rhythm } from 'components/Layout/Rhythm';

import styles from './styles.css';

export const Radio = ({ items, input, onChange, horizontal }) => (
  <Rhythm vertical={!horizontal}>
    {items.map((item, i: number) => (
      <label className={styles.root} key={i}>
        <input
          className={styles.input}
          type="radio"
          checked={input.value === item.value}
          value={item.value}
          onChange={onChange}
        />
        <span className={styles.checkbox} />
        <span className={styles.title}>{item.title}</span>
      </label>
    ))}
  </Rhythm>
);

export default withField(Radio);
